export default [
  {
    path: '/mission-event',
    component: () => import('./views/Index'),
    name: 'mission-event',
    redirect: { name: 'mission-event-list' },
    children: [
      {
        path: '',
        name: 'mission-event-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
      {
        path: 'detail/:event_id',
        name: 'mission-event-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
